import type { ParticipantToPayDto } from '@/api/core-api/types.gen';

/** A row in the "Participants to pay" table — straight from the server. */
export type ToPayRow = ParticipantToPayDto;

/**
 * Stable React key for a to-pay row. The server returns one row per
 * surveyResponseId, so that id alone is unique within a page.
 */
export function rowKey(row: ToPayRow): string {
  return row.surveyResponseId;
}

/** Row key for a deep-linked surveyResponseId, or undefined if it isn't in `rows`. */
export function findPreselectKey(
  rows: ToPayRow[],
  surveyResponseId: string,
): string | undefined {
  const row = rows.find((r) => r.surveyResponseId === surveyResponseId);
  return row ? rowKey(row) : undefined;
}

const ORDINAL_SUFFIXES = ['th', 'st', 'nd', 'rd'] as const;

export function ordinal(n: number): string {
  const v = n % 100;
  return (
    n +
    (ORDINAL_SUFFIXES[(v - 20) % 10] ??
      ORDINAL_SUFFIXES[v] ??
      ORDINAL_SUFFIXES[0])
  );
}
